export default __webpack_public_path__ + "static/jaromir-kavan-vv-oEGlN-4E-unsplash-7d20dd3f66a30fce152e644091367ca3.jpg";